import { c as _c } from "react/compiler-runtime";
import { DesignPrintSummary } from './steps/DesignPrintSummary';

/**
 * A design page: what it gives you, and what you are aiming for.
 *
 * The curve comes first, at the width of the page, and the target under it,
 * where the mockup puts it in a column beside: eighty-eight keys read across,
 * and the column took a third of the page away from them. Above the curve,
 * the cards pushed it off a laptop's screen, and moved it each time a choice
 * brought controls of a different height. Under it, the whole curve is on the
 * screen when the page opens, nothing a choice does moves it, and a step of a
 * control is read on it with the control in view.
 */
export const DesignLayout = t0 => {
  const $ = _c(6);
  const {
    chart,
    objective
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DesignPrintSummary />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== objective) {
    t2 = <div className="max-w-[var(--ptl-text-measure)] print:hidden">{objective}</div>;
    $[1] = objective;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== chart || $[4] !== t2) {
    t3 = <div data-slot="page-wide" className="flex flex-col gap-6">{t1}{chart}{t2}</div>;
    $[3] = chart;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};